import { Image, ImageStyle, StyleProp, useColorScheme, Platform } from 'react-native';

interface LogoProps {
  style?: StyleProp<ImageStyle>;
  size?: 'small' | 'medium' | 'large' | 'mobile';
}

/**
 * A reusable Logo component that automatically switches between light and dark versions
 * based on the current color scheme.
 */
export const Logo = ({ style, size = 'medium' }: LogoProps) => {
  const colorScheme = useColorScheme();
  
  // Determine logo source based on color scheme
  const logoSource = colorScheme === 'dark'
    ? require('../../assets/images/logo-dark.png')
    : require('../../assets/images/logo-light.png');
  
  // Define size presets with a larger mobile-specific size
  const sizeStyles: Record<string, StyleProp<ImageStyle>> = {
    small: { width: 100, height: 50 },
    medium: { width: 140, height: 70 },
    large: { width: 200, height: 100 },
    mobile: { width: 130, height: 65 }, // Tamanho adequado para header mobile
  };
  
  return (
    <Image
      source={logoSource}
      resizeMode="contain"
      style={[sizeStyles[size], style]}
    />
  );
};

export default Logo; 